import React, { useEffect, useState } from "react";
import ConfigETC from "../Class/ConfigETC.json";
import {
  Return_thisWeekDate_Array ,
  formatDate,
  datagridtoolbarDynamicOptions,
  ConvertMiniutDuration_calbyconfig,
  excelExportProperties_ProjectView_Transaction,
  pdfExportProperties_ProjectView_Transaction,
  csvExportProperties_ProjectView_Transaction,
  Bind_Presets_Calendar,
  Bind_Select_Status,
  HtmlTooltip,
} from "../Class/Class_Etc";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { updateSampleSection } from "../Main/Sample-base";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Sort,
  Inject,
  Toolbar,
  ExcelExport,
  Resize,
  PdfExport,
  Group,
  Reorder,
} from "@syncfusion/ej2-react-grids"; //synfusion data grid


import Select from "react-select";
import SelectTaskMultiGroup from "../Library/Select_TaskMultiGroup";
import SelectStaff from "../Library/Select_Staff";
import SelectTimeoff from "../Library/Select_Timeoff";
import { customStylesSelect } from "../Class/Class_Etc"	
import { CP_CheckPermission } from "../Class/Class_Permission";
	
	
/*

  Edit BY POOM : 09-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
    - เพิ่ม การดึงข้อมูล extra_day , travel_distance

*/


function PV_Transaction(props) {

  //#region __ Declare __
  const [listdata , setListdata ] = useState([])
  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  
  const thisWeekDate = Return_thisWeekDate_Array();
  const [dateRangeText, setDateRangeText] = useState(null)
  const [dateRange, setDateRange] = useState([thisWeekDate.DateStart_td,thisWeekDate.DateEnd_td]);
  const [startDate, endDate] = dateRange;

  const dataPresets = Bind_Presets_Calendar();
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [iscntreset , setIscntreset] = useState(0);
  
  
  const [selectsearchTask, setSelectsearchTask] = useState(null);
  const [selectsearchStaff, setSelectsearchStaff] = useState(null);
  const [selectsearchTimeoff, setSelectsearchTimeoff] = useState(null);
  const [selectsearchStatus , setSelectsearchStatus] = useState(null);


  const [searchdetailTask, setSearchdetailTask] = useState("");
  const [searchdetailStaff, setSearchdetailStaff] = useState("");
  const [searchdetailTimeoff, setSearchdetailTimeoff] = useState("");
  const [searchdetailStatus , setSearchdetailStatus] = useState("");
  const [searchdetailDate , setSearchdetailDate] = useState("");

  //#endregion

  //#region useEffect
  useEffect(() => {
    if (isFirst === true) {
      GetConfig();
      if (isLoadedConfigData === true && props.actiontabtran === 0) {
        BindList("" , "" , "" , thisWeekDate.DateStart_ts , thisWeekDate.DateEnd_ts , "" , function() {
          GetDateRangeText(thisWeekDate.DateStart_ts,thisWeekDate.DateEnd_ts)
          GetDateRangeDetailText(thisWeekDate.DateStart_ts,thisWeekDate.DateEnd_ts)
          setIsLoadProgress(false);
          setIsFirst(false);
        });
      }
      updateSampleSection();
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);
  
  useEffect(() => {

    if (props.actiontabtran) {
      if (isLoadedConfigData === true && props.actiontabtran > 0){
        actionSearch();
      }
      else{
        GetConfig();
      }
      
    }
    // eslint-disable-next-line
  }, [props.actiontabtran , isLoadedConfigData]);



  //#endregion

  //#region __ Function __

  function actionSearch(){
    
    let action = document.getElementById("hd_tran_status_action").value
    const labelstatus = {
      10: ConfigETC.TS_ToReview_Text,
      11: ConfigETC.TS_ToApprove_Text,
      20: ConfigETC.TS_Approved_Text,
      30: ConfigETC.TS_Clearing_Text,
      12: ConfigETC.TS_Reject_Text,
    };
    setSelectsearchStatus([{ value : action, label : labelstatus[action] }])
    setIscntreset((iscntreset) => iscntreset + 1);
    setSelectsearchTask(null);
    setSelectsearchStaff(null);
    setSelectsearchTimeoff(null);
    setDateRange([null,null]);

    let ValueTask = ""
    let ValueTasktext = ""
    let ValueStaff = ""
    let ValueStaffText = ""
    let ValueTimeoff = ""
    let ValueTimeofftext = ""
    let ValueDateS = ""
    let ValueDateE = ""
    let ValueStatus = action.toString()
    let ValueStatustext = labelstatus[action]

    GetDateRangeText(ValueDateS , ValueDateE)
    GetDateRangeDetailText(ValueDateS,ValueDateE)
    setSearchdetailTask(ValueTasktext);
    setSearchdetailStaff(ValueStaffText);
    setSearchdetailTimeoff(ValueTimeofftext);
    setSearchdetailStatus(ValueStatustext);
    setIsLoadProgress(true);
    BindList(ValueTask , ValueStaff , ValueTimeoff , ValueDateS , ValueDateE , ValueStatus , function() {
      if (document.getElementById("collapseTran").className === "collapse") {
        document.getElementById("btn_tran_collapse").click();
      }
      setIsLoadProgress(false);
    });

  }
  
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
    }

  function GetDateRangeText(DateStart , DateEnd){

    if (DateStart === "" && DateEnd === "")
    {
      setDateRangeText(" - ");
    }
    else
    {
      setDateRangeText(DateStart + (DateStart !== "" && DateEnd !== "" ? " - " : "") + DateEnd);
    }
  }

  function GetDateRangeDetailText(DateStart , DateEnd){

    if (DateStart === "" && DateEnd === "")
    {
      setSearchdetailDate("");
    }
    else
    {
      setSearchdetailDate(DateStart + (DateStart !== "" && DateEnd !== "" ? " - " : "") + DateEnd);
    }
  }

  async function BindList(task_id , 
    staff_id , 
    timeoff_id , 
    date_start , 
    date_end , 
    status , 
    _callback){

      try {
        let token = "";
        token = localStorage.getItem("TStoken");
        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);
        myHeaders.append("Content-Type", "application/json");
  
        var raw = JSON.stringify({
          "pro_id": props.entity.pro_id.toString(),
          "task_id_str": task_id,
          "staff_id_str": staff_id,
          "timeoff_id_str": timeoff_id,
          "date_start_str": date_start,
          "date_end_str": date_end,
          "status": status
        });


        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };
  
        const response = await fetch(
          configData.API_URL + "Project_Tran_GetList",
          requestOptions
        );
  
        const json = await response.json();
        if (json.status_ID === 1) {
          if (json.total_Data > 0) {
            setListdata(json.data);
            if (_callback != null) {
              _callback();
            }
          } else {
            setListdata([]);
            if (_callback != null) {
              _callback();
            }
          }
        }
        else
        {
          setListdata([]);
          if (_callback != null) {
            _callback();
          }
        }
      } catch {

        setListdata([]);
        if (_callback != null) {
          _callback();
        }
      }


  }

  //#endregion 

  //#region __ Event __

  function onChangevaluesTask(e)
  {
    setSelectsearchTask(e)
  }
  
  function onChangevaluesStaff(e)
  {
    setSelectsearchStaff(e)
  }
  
  function onChangevaluesTimeoff(e)
  {
    setSelectsearchTimeoff(e)
  }
  
  const onChangeDateRange = (dates) => {
    if(typeof dates.value === 'undefined' || dates.value === null)
    {
        setDateRange([null,null]);
    }else{
        setDateRange(dates.value);
    }
  };  
  
  function onclickReset(){
    setIscntreset((iscntreset) => iscntreset + 1);
    setSelectsearchStatus(null)
    setDateRange([thisWeekDate.DateStart_td,thisWeekDate.DateEnd_td])
  }
  
  function onclickSearch(){

    let ValueTask = ""
    let ValueTasktext = ""
    let ValueStaff = ""
    let ValueStaffText = ""
    let ValueTimeoff = ""
    let ValueTimeofftext = ""
    let ValueDateS = ""
    let ValueDateE = ""
    let ValueStatus = ""
    let ValueStatustext = ""


    if (selectsearchTask !== null) {
      if (selectsearchTask.length > 0) {
        for (let i = 0; i < selectsearchTask.length; i++) {
          ValueTask = ValueTask + (ValueTask === "" ? "" : ",") + selectsearchTask[i].value;
          ValueTasktext = ValueTasktext + (ValueTasktext === "" ? "" : ",") + selectsearchTask[i].label;
        }
      }
    }

    if (selectsearchStaff !== null) {
      if (selectsearchStaff.length > 0) {
        for (let i = 0; i < selectsearchStaff.length; i++) {
          ValueStaff = ValueStaff + (ValueStaff === "" ? "" : ",") + selectsearchStaff[i].value;
          ValueStaffText = ValueStaffText + (ValueStaffText === "" ? "" : ",") + selectsearchStaff[i].label;
        }
      }
    }


    if (selectsearchTimeoff !== null) {
      if (selectsearchTimeoff.length > 0) {
        for (let i = 0; i < selectsearchTimeoff.length; i++) {
          ValueTimeoff = ValueTimeoff + (ValueTimeoff === "" ? "" : ",") + selectsearchTimeoff[i].value;
          ValueTimeofftext = ValueTimeofftext + (ValueTimeofftext === "" ? "" : ",") + selectsearchTimeoff[i].label;
        }
      }
    }
    
    if (selectsearchStatus !== null) {
      if (selectsearchStatus.length > 0) {
        for (let i = 0; i < selectsearchStatus.length; i++) {
          ValueStatus = ValueStatus + (ValueStatus === "" ? "" : ",") + selectsearchStatus[i].value;
          ValueStatustext = ValueStatustext + (ValueStatustext === "" ? "" : ",") + selectsearchStatus[i].label;
        }
      }
    }


    let date_rang = document.getElementById("txt_PV_Tran_SearchDate").value;
    if (date_rang !== "")
    {
      let datevalue =  date_rang.split(" - ");
      if (datevalue.length === 2)
      {
        ValueDateS = datevalue[0];
        ValueDateE   = datevalue[1];
      }
    }

    GetDateRangeText(ValueDateS , ValueDateE)
    GetDateRangeDetailText(ValueDateS,ValueDateE)
    setSearchdetailTask(ValueTasktext);
    setSearchdetailStaff(ValueStaffText);
    setSearchdetailTimeoff(ValueTimeofftext);
    setSearchdetailStatus(ValueStatustext);

    setIsLoadProgress(true);
    BindList(ValueTask , ValueStaff , ValueTimeoff , ValueDateS , ValueDateE , ValueStatus , function() {
      setIsLoadProgress(false);
    });
  }
  
  
  //#endregion

  //#region __ Grid __

  let gridInstance;
  let gridInstancePrint;

  function beforePrint(args) {
    let theadEle = gridInstance.element
      .querySelector(".e-gridheader .e-headercontent thead")
      .cloneNode(true);
    let arrOfMOM = theadEle.children;
    args.element
      .querySelector(".e-gridheader .e-headercontent thead")
      .replaceChildren(...[].slice.call(arrOfMOM));
  }

  function toolbarClick(args) {
    
    let Project = props.entity.pro_name;
    let Task = searchdetailTask;
    let Staffs = searchdetailStaff;
    let Timeoff = searchdetailTimeoff;
    let Daterang = searchdetailDate;
    let Status = searchdetailStatus;
    
    const DateExport = new Date();
    const DateExport1 = formatDate(
      DateExport,
      "short en",
      "en",
      "",
      "datetimeexport"
    );
    const DateExport2 = formatDate(
      DateExport,
      "short en",
      "en",
      "/",
      "datetime"
    );

    let Excelname = "Project_Transaction_" + DateExport1 + ".xlsx";
    let PDFname = "Project_Transaction_" + DateExport1 + ".pdf";
    let Csvname = "Project_Transaction_" + DateExport1 + ".csv";
    let Report = "Project Transaction";

    let colSpan = 12 - (isSVOT ? 0 : 1);

    if (gridInstance && args.item.id === "ExcelExport") {
      gridInstance.excelExport(
        excelExportProperties_ProjectView_Transaction(
          Excelname,
          Report,
          Project,
          Task,
          Staffs,
          Timeoff,
          Daterang,
          Status,
          colSpan,
          DateExport2
        )
      );
    }

    if (gridInstance && args.item.id === "PdfExport") {

      gridInstance.pdfExport(
        pdfExportProperties_ProjectView_Transaction(
          PDFname,
          Report,
          Project,
          Task,
          Staffs,
          Timeoff,
          Daterang,
          Status,
          DateExport2
        )
      );
    }

    if (gridInstance && args.item.id === "CsvExport") {

      gridInstance.csvExport(
        csvExportProperties_ProjectView_Transaction(
          Csvname,
          Report,
          Project,
          Task,
          Staffs,
          Timeoff,
          Daterang,
          Status,
          colSpan,
          DateExport2
        )
      );
    }

    if (gridInstance && args.item.id === "Print") {
      
      gridInstancePrint.print();
    }
  }

  function faclockTemplate(props) {
    return (
      <div>
        <span className="far fa-clock text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }
  
  function falightTemplate(props) {
    return (
      <div>
        <span className="far fa-lightbulb text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }
  
  function fabtcTemplate(props) {
    return (
      <div>
        <span className="fab fa-btc text-muted"></span>
        &nbsp; {props.headerText}
      </div>
    );
  }

  const valueAccessDHM = (field, data) => {
    return  ConvertMiniutDuration_calbyconfig(data[field]) ;
  };
  
  const valueTemp_Ts_Date = (props) => {
    let day = props.ts_Date.slice(0, 5);
    let date = props.ts_Date.slice(5);
    return (<>
            <span className="text-muted text-smaller">{day}</span> {date}
            </>)
  };
  
  const valueTemp_task_timeoff = (props) => {
    let value = props.task_timeoff;

    if (props.type_tasktimeoff === "T")
    {
      return (<>
                {value} {Return_i_note(props.note)}
              </>)
    }
    else
    {
      return (<>
                <span className="text-italic text-muted">Time Off:</span>{value} {Return_i_note(props.note)}
              </>)
    }
  }

  function Return_i_note(note)
  {
    if (note !== "")
    {
      return (<>
      <HtmlTooltip
      title={
        <>
          <div>note : {note}</div>
        </>
      }
      >
      <i className="fas fa-info-circle tip text-muted"  ></i>
      </HtmlTooltip>
      </>)
    }
    else
    {
      return (<></>)
    }
  }

  const valueTemp_staff_fullname=(props)=>{

    return (
    <>
      <div className="staffs-list">
        {props.staff_fullname}{" "}
        <HtmlTooltip
        title={
          <>
            <div>
              Department:{props.department_name},Position:{props.position_name}
            </div>
          </>
        }
        >
        <i className="fas fa-info-circle tip text-muted"  ></i>
        </HtmlTooltip>
        {/* <i className="fas fa-info-circle tip text-muted" data-toggle="tooltip" 
        title={"Department:" + props.department_name +  ",Position:" + props.position_name }>
        </i> */}
      </div>
    </>
    )
  }

  const valueTemp_ts_status=(props)=>{
    
    const valueStatusReturn = {
      0: <span className={ConfigETC.TS_InProgress_Class + " text-smaller"} title={ConfigETC.TS_InProgress_Text}>{ConfigETC.TS_InProgress_Text}</span>,
      10: <span className={ConfigETC.TS_ToReview_Class + " text-smaller"} title={ConfigETC.TS_ToReview_Text}>{ConfigETC.TS_ToReview_Text}</span>,
      11: <span className={ConfigETC.TS_ToApprove_Class + " text-smaller"} title={ConfigETC.TS_ToApprove_Text}>{ConfigETC.TS_ToApprove_Text}</span>,
      20: <span className={ConfigETC.TS_Approved_Class + " text-smaller"} title={ConfigETC.TS_Approved_Text}>{ConfigETC.TS_Approved_Text}</span>,
      30: <span className={ConfigETC.TS_Clearing_Class + " text-smaller"} title={ConfigETC.TS_Clearing_Text}>{ConfigETC.TS_Clearing_Text}</span>,
      12: <span className={ConfigETC.TS_Reject_Class + " text-smaller"} title={ConfigETC.TS_Reject_Text}>{ConfigETC.TS_Reject_Text}</span>,
    };

    const valueRejectReturn = {
      1: (
        <HtmlTooltip
          title={
            <>
              <div className="">
                Reject Desc : {props.reject_desc} | By : {props.reject_by}
              </div>
            </>
          }
        >
          <i className="fas fa-registered tip text-muted text-red"></i>
        </HtmlTooltip>
      ),
    };

    return (
      <>
        {valueStatusReturn[props.ts_status]} {valueRejectReturn[props.is_reject]}
      </>
      )
  }


  //#endregion

  return (
    <>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      
        <div>

          <div className="card-header">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="text-center">
                    {" "}
                    <h6> {dateRangeText}</h6>
                  </div>
                  <div className="search-icon float-right">
                    <button
                      id="btn_tran_collapse"
                      type="button"
                      className="btn btn-tool"
                      data-toggle="collapse"
                      href="#collapseTran"
                    >
                      <i className="fas fa-filter" /> Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="table-bordered bg-light" id="accordionTran">
            <div className="row" >
              <div className="col-md-12">
                <div
                  className="collapse"
                  id="collapseTran"
                  data-parent="#accordionTran"
                >

                  <div className="row m-0">
                    <div className="col-lg-3 col-12">
                      <div className="form-group m-0">
                        <label className="text-small p-0 m-0">Date</label>
                        <div className="input-group">
                          <DateRangePickerComponent 
                              id="txt_PV_Tran_SearchDate"
                              placeholder='Select a range' 
                              format='dd/MM/yyyy'
                              startDate={startDate}
                              endDate={endDate}
                              onChange={onChangeDateRange}
                              presets={dataPresets}
                              strictMode={true}
                              size="m"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-12">
                      <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Task</label>
                          {isLoadedConfigData && (
                            <SelectTaskMultiGroup
                              API_URL={configData.API_URL}
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={onChangevaluesTask}
                              iscloseMenuOnSelect={false}
                            ></SelectTaskMultiGroup>
                          )}
                        </div>
                    </div>
                    <div className="col-lg-5 col-12">
                      <div className="form-group m-0">
                          <label className="text-small p-0 m-0">Staffs</label>
                          {isLoadedConfigData && (
                            <SelectStaff
                              API_URL={configData.API_URL}
                              staff_status={"-1"}
                              selectismulti={true}
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={onChangevaluesStaff}
                              iscloseMenuOnSelect={false}
                            ></SelectStaff>
                          )}
                        </div>
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-lg-3 col-6"></div>
                    <div className="col-lg-4 col-12">
                      <div className="form-group m-0">
                          <label className="text-small p-0 m-0">TimeOff</label>
                          {isLoadedConfigData && 
                            <SelectTimeoff 
                              API_URL={configData.API_URL}
                              timeoff_status={"-1"}
                              selectismulti={true} 
                              SelectTextDefault={ConfigETC.ddl_All}
                              resetSelect={iscntreset}
                              onChangevalue={onChangevaluesTimeoff}
                              iscloseMenuOnSelect={false}
                              ></SelectTimeoff>
                            }
                        </div>
                    </div>
                    <div className="col-lg-5 col-12">
                      <div className="form-group m-0">
                          <label className="text-small p-0 m-0">
                            Timesheet Status
                          </label>
                          <Select
                            closeMenuOnSelect={false}
                            placeholder={ConfigETC.ddl_All}
                            isMulti
                            value={selectsearchStatus}
                            options={Bind_Select_Status("Rp_Sum_pro")}
                            menuPortalTarget={document.body}
                            onChange={(e) => setSelectsearchStatus(e)}
                            styles={customStylesSelect}
                          />
                        </div>
                    </div>
                  </div>
                  <div className="row mt-3 p-0 mb-3">
                    <div className="col-12 text-center">
                      <div className="form-group m-0">
                          
                          <div >
                            <button type="button" id="btn_tabtranSearch" className="btn btn-primary btn-sm" onClick={onclickSearch} >
                              <i className="fas fa-search" /> Search
                            </button>
                            {" "}
                            <button type="button" className="btn btn-default btn-sm" onClick={onclickReset} >
                              <i className="fas fa-times" /> reset
                            </button>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* /.card-header */}
          <div className="card-body border-0 m-0 p-0">
            
            <GridComponent
              id="dg_Project_Tran"
              dataSource={listdata}
              allowPaging={true}
              allowSorting={true}
              allowResizing={true}
              allowReordering={true}
              pageSettings={{ pageCount: ConfigETC.pageCount,pageSize: ConfigETC.rowsPerPage,}}
              ref={(grid) => (gridInstance = grid)}
              toolbar={datagridtoolbarDynamicOptions(
                listdata,
                true,
                true,
                true,
                true,
                true
              )}
              toolbarClick={toolbarClick.bind(this)}

              allowExcelExport={true}
              allowPdfExport={true}
              allowGrouping={false}
              beforePrint={beforePrint.bind(this)}
              hierarchyPrintMode="All"
            >
              <ColumnsDirective>
              
                <ColumnDirective
                  field="rowindex"
                  headerText="#"
                  width="3%"
                  textAlign="left"
                  allowSorting={false}
                ></ColumnDirective>

                <ColumnDirective
                  field="ts_Date"
                  headerText="Date"
                  width="13%"
                  template={valueTemp_Ts_Date}
                  allowSorting={false}
                ></ColumnDirective>

                <ColumnDirective
                  field="task_timeoff_excel"
                  headerText="Tasks/TimeOff"
                  width="15%"
                  template={valueTemp_task_timeoff}
                  allowSorting={true}
                ></ColumnDirective>

                <ColumnDirective
                  field="staff_fullname_excel"
                  headerText="Staffs"
                  width="15%"
                  allowSorting={true}
                  template={valueTemp_staff_fullname}
                ></ColumnDirective>

                <ColumnDirective
                  field="wt"
                  headerText="WT"
                  width="9%"
                  allowSorting={true}
                  valueAccessor={valueAccessDHM}
                  headerTemplate={faclockTemplate}
                ></ColumnDirective>

                {isSVOT &&
                  <ColumnDirective
                    field="ot"
                    headerText="OT"
                    width="9%"
                    allowSorting={true}
                    valueAccessor={valueAccessDHM}
                    headerTemplate={falightTemplate}
                  ></ColumnDirective>
                }

                <ColumnDirective
                  field="extra"
                  headerText="Per diem allowance"
                  width="15%"
                  allowSorting={true}
                  format="N2"
                  headerTemplate={fabtcTemplate}
                ></ColumnDirective>

                <ColumnDirective
                  field="extra_day"
                  headerText="Per diem allowance (day)"
                  width="18%"
                  allowSorting={true}
                  format="N2"
                ></ColumnDirective>

                <ColumnDirective
                  field="travel"
                  headerText="Travel"
                  width="9%"
                  allowSorting={true}
                  format="N2"
                  headerTemplate={fabtcTemplate}
                ></ColumnDirective>

                <ColumnDirective
                  field="travel_distance"
                  headerText="Travel (distance)"
                  width="9%"
                  allowSorting={true}
                  format="N2"
                ></ColumnDirective>

                <ColumnDirective
                  field="other"
                  headerText="Other"
                  width="9%"
                  allowSorting={true}
                  format="N2"
                  headerTemplate={fabtcTemplate}
                ></ColumnDirective>

                <ColumnDirective
                  field="ts_status_excel"
                  headerText="Status"
                  width="9%"
                  allowSorting={true}
                  template={valueTemp_ts_status}
                ></ColumnDirective>

              </ColumnsDirective>
              <Inject services={[Page,
                                Sort,
                                Toolbar,
                                ExcelExport,
                                PdfExport,
                                Group,
                                Resize,
                                Reorder,]} />
            </GridComponent>

            <div style={{display : "none"}} >
              <GridComponent
                id="dg_Project_Tran_Print"
                dataSource={listdata}
                allowPaging={true}
                allowSorting={true}
                allowResizing={true}
                allowReordering={true}
                pageSettings={{ pageCount: ConfigETC.pageCount,pageSize: ConfigETC.rowsPerPage,}}
                ref={(grid) => (gridInstancePrint = grid)}
                toolbar={datagridtoolbarDynamicOptions(
                  listdata,
                  true,
                  true,
                  true,
                  true,
                  true
                )}
                toolbarClick={toolbarClick.bind(this)}

                allowExcelExport={true}
                allowPdfExport={true}
                allowGrouping={false}
                beforePrint={beforePrint.bind(this)}
                hierarchyPrintMode="All"
              >
                <ColumnsDirective>
                
                  <ColumnDirective
                    field="rowindex"
                    headerText="#"
                    width="3%"
                    textAlign="left"
                    allowSorting={false}
                  ></ColumnDirective>

                  <ColumnDirective
                    field="ts_Date"
                    headerText="Date"
                    width="13%"
                    allowSorting={false}
                  ></ColumnDirective>

                  <ColumnDirective
                    field="task_timeoff_excel"
                    headerText="Tasks/TimeOff"
                    width="15%"
                    allowSorting={true}
                  ></ColumnDirective>

                  <ColumnDirective
                    field="staff_fullname_excel"
                    headerText="Staffs"
                    width="15%"
                    allowSorting={true}
                  ></ColumnDirective>

                  <ColumnDirective
                    field="wt"
                    headerText="WT"
                    width="9%"
                    allowSorting={true}
                    valueAccessor={valueAccessDHM}
                    headerTemplate={faclockTemplate}
                  ></ColumnDirective>

                  {isSVOT &&
                    <ColumnDirective
                      field="ot"
                      headerText="OT"
                      width="9%"
                      allowSorting={true}
                      valueAccessor={valueAccessDHM}
                      headerTemplate={falightTemplate}
                    ></ColumnDirective>
                  }

                  <ColumnDirective
                    field="extra"
                    headerText="PER DIEM ALLOWANCES"
                    width="15%"
                    allowSorting={true}
                    format="N2"
                    headerTemplate={fabtcTemplate}
                  ></ColumnDirective>
                  <ColumnDirective
                    field="extra"
                    headerText="PER DIEM ALLOWANCES (day)"
                    width="18%"
                    allowSorting={true}
                    format="N2"
                  ></ColumnDirective>

                  <ColumnDirective
                    field="travel"
                    headerText="Travel"
                    width="9%"
                    allowSorting={true}
                    format="N2"
                    headerTemplate={fabtcTemplate}
                  ></ColumnDirective>
                  <ColumnDirective
                    field="travel_distance"
                    headerText="Travel (distance)"
                    width="11%"
                    allowSorting={true}
                    format="N2"
                  ></ColumnDirective>

                  <ColumnDirective
                    field="other"
                    headerText="Other"
                    width="9%"
                    allowSorting={true}
                    format="N2"
                    headerTemplate={fabtcTemplate}
                  ></ColumnDirective>

                  <ColumnDirective
                    field="ts_status_excel"
                    headerText="Status"
                    width="9%"
                    allowSorting={true}
                  ></ColumnDirective>

                </ColumnsDirective>
                <Inject services={[Page,
                                  Sort,
                                  Toolbar,
                                  ExcelExport,
                                  PdfExport,
                                  Group,
                                  Resize,
                                  Reorder,]} />
              </GridComponent>

            </div>

          </div>
        </div>
    
    </>
  );
}

export default PV_Transaction;
